import DomComponent from '../lib/domComponent';

export default class HeaderComponent extends DomComponent {
    static selector = '[data-js-footer]';
    inactiveLinks = [];
    el;

    constructor(el) {

        super(el);

        this.inactiveLinks = this.el.querySelectorAll('[data-disabled]');

        for(let i = 0; i < this.inactiveLinks.length; i++){
            this.inactiveLinks[i].classList.add('inactive-link');
            this.inactiveLinks[i].insertAdjacentHTML('beforeend', '<span class="tooltiptext">Coming Soon</span>');
        }

        setTimeout(() => {
            this.loaded();
        })
    }
} 